import {
  createEntityAdapter,
  createSlice,
  PayloadAction,
} from "@reduxjs/toolkit";

import { defaultGenericMeta, FilterProps } from "store/common";

import {
  FetchStatementsResult,
  StatementData,
  StatementsState,
} from "./statements-state";
import { fetchStatements } from "./statements-action";
import { RootState } from "store";

const statementsEntityAdapter = createEntityAdapter<StatementData>({
  selectId: (e) => e.fileId,
});

export const statementsSlice = createSlice({
  name: "statements",
  initialState: statementsEntityAdapter.getInitialState<StatementsState>({
    meta: { ...defaultGenericMeta },
  }),
  reducers: {
    setFilters(state, action: PayloadAction<FilterProps>) {
      state.filters = {
        ...state.filters,
        ...action.payload,
      };
    },
    clearFilter(state) {
      state.filters = null;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(
      fetchStatements.fulfilled,
      (state, action: PayloadAction<FetchStatementsResult>) => {
        state.meta.isLoading = false;
        state.meta.isSuccess = true;
        state.meta.error = null;
        state.meta.status = "idle";
        const { results, ...serviceMeta } = action.payload;
        statementsEntityAdapter.setAll(state, results);
        state.serviceMeta = serviceMeta;
      },
    );
    builder.addCase(fetchStatements.pending, (state) => {
      state.meta.isLoading = true;
      state.meta.status = "inProcess";
    });
    builder.addCase(fetchStatements.rejected, (state) => {
      state.meta.isLoading = false;
      state.meta.status = "idle";
      state.meta.error = "true";
    });
  },
});

export const { selectAll: selectAllStatments } =
  statementsEntityAdapter.getSelectors((state: RootState) => state.statements);

export const { setFilters, clearFilter } = statementsSlice.actions;
export default statementsSlice.reducer;
